import { Component, DestroyRef, OnDestroy, inject } from '@angular/core';
import { ClientKnowledgeAsync } from '../store/clientKnowledge/async';
import { getError, isFetching } from '../store/clientKnowledge/selector';
import { IClientKnowledgeState } from '../store/clientKnowledge/state';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-client-knowledge',
    template: `
      <app-clientknowledge
        [error]="error()"
        [isFetching]="fetching()"
        (openClientKnowledge)="openClientKnowledge()"></app-clientknowledge>
    `,
    standalone: false
})

export class ClientKnowledgeContainer implements OnDestroy {
  luxId = 'BMT-ClientKnowledge-Comp' + this.constructor.name;
  private readonly destroyRef = inject(DestroyRef);
  error = toSignal(this.lux.get(getError, this.luxId), { initialValue: '' });
  fetching = toSignal(this.lux.get(isFetching, this.luxId), { initialValue: false });

  constructor(private readonly async: ClientKnowledgeAsync,
              private readonly lux: Lux<{ clientKnowledgeState: IClientKnowledgeState }>) {}

  ngOnDestroy() {
    this.lux.destroy(this.luxId);
  }

  openClientKnowledge(): void {
    this.async.getClientKnowledgeURLKey()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (this.error()) {
          return;
        }

        const url = this.toSafeWebUrl(response);
        if (!url) {
          return;
        }

        const openedWindow = window.open(url, 'Client Knowledge Reports', `noopener,noreferrer,height=${screen.height},width=${screen.width}`);
        if (openedWindow) {
          openedWindow.opener = null;
        }
      });
  }

  private toSafeWebUrl(candidateUrl: string | null | undefined): string {
    if (!candidateUrl) {
      return '';
    }

    try {
      const resolvedUrl = new URL(candidateUrl, window.location.origin);
      return ['http:', 'https:'].includes(resolvedUrl.protocol) ? resolvedUrl.toString() : '';
    } catch {
      return '';
    }
  }
}
